import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.less';
import { PageData } from './declarations';
import Layout from './Layout';

const App: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [pages, setPages] = useState<PageData[]>([]);

    useEffect(() => {
        getPages();
    }, []);

    const getPages = async () => {
        setLoading(true);
        var resp = await fetch(`./examples.json`);
        if (resp.ok) {
            resp.json().then(json => {
                setPages(json);
                setLoading(false);
            });
        }
    }

    return (<div className="App">
        <Switch>
            <Route exact path={`/`} render={() => <Layout main={true} pages={pages} loading={loading} />} />
            <Route exact path={`/:page`} render={(props) => <Layout main={false} pages={pages} loading={loading} pageData={pages.filter((item: PageData) => item.link === props.match.params.page)[0]} />} />
        </Switch>
    </div>);
};

export default App;